import * as moment from 'moment/moment';
import { Address } from './address';
import { MarketType } from './market-type';
import { Name } from './name';
import { DealerLicenseStatus } from './dealer-license-status';
import { DealerComment } from './dealer-comment';

/**
 * Dealer Profile.
 */
export class DealerProfile {

  readonly businessAddress: Address;

  readonly businessEmail: string;

  readonly businessName: string;

  readonly businessPhone: string;

  readonly comments: DealerComment[];

  readonly contactName: Name;

  readonly expirationDate: Date;

  readonly faxNumber: string;

  readonly id: number;

  readonly bulkDataReport: boolean;

  readonly mailingAddress: Address;

  readonly marketContactName: Name;

  readonly marketFax: string;

  readonly marketPhone: string;

  readonly marketTypes: Set<MarketType>;

  readonly status: DealerLicenseStatus;

  static fromJSON(jsonObject: any): DealerProfile {
    const result = Object.create(DealerProfile.prototype);

    Object.assign(result, jsonObject, {
      businessAddress: jsonObject.businessAddress ? Address.fromJSON(jsonObject.businessAddress) : null,
      comments: jsonObject.comments ? (jsonObject.comments as any[]).map(element => DealerComment.fromJSON(element)) : null,
      expirationDate: jsonObject.expirationDate ? moment(jsonObject.expirationDate).toDate() : null,
      id: jsonObject.licenseNumber ? Number(jsonObject.licenseNumber) : null,
      mailingAddress: jsonObject.mailingAddress ? Address.fromJSON(jsonObject.mailingAddress) : null,
      marketTypes: jsonObject.marketTypes ? new Set((jsonObject.marketTypes as any[]).map(element => MarketType.fromString(element))) : null,
      status: jsonObject.status ? DealerLicenseStatus.fromString(jsonObject.status) : null
    });
    return result;
  }

}
